import React from 'react';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';




const FormDialog = (props) => {
    const { open, handleClose, input, onConfirm, onChange } = props;

  return (
    <div>
      {/* <Button variant="outlined" color="primary" onClick={handleClickOpen}>
        Greetings Adventurer!
      </Button> */}
      <Dialog open={open} onClose={handleClose} aria-labelledby="form-dialog-title">
        <DialogTitle id="form-dialog-title">Greetings Adventurer!</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Please enter your character name
          </DialogContentText>
          <TextField
            autoFocus
            margin="dense"
            id="name"
            label="New character"
            type="text"
            value={input}
            onChange={onChange}
           
          
          />
        </DialogContent>
        <DialogActions>
          <Button variant="contained" onClick={handleClose} color="default">
            Cancel
          </Button>
          <Button variant="contained" onClick={onConfirm} color="secondary">
            Continue
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default FormDialog;
